'use client'

import { useEffect } from 'react'
import { setElementVars } from '@vanilla-extract/dynamic'
import { tokens } from 'ui/src/theme/tokens.css'
import { textDecorationHoverColor } from '@/components/TextLink/TextLink.css'

const HOVER_COLORS = [
  tokens.colors.peril.blue.fill2,
  tokens.colors.peril.green.fill2,
  // There's no non-legacy counterpart
  tokens.legacyColors.amber600,
  tokens.colors.peril.red.fill2,
  tokens.colors.peril.pink.fill2,
  tokens.colors.peril.purple.fill2,
  tokens.colors.peril.teal.fill2,
]

export function RandomHoverColor() {
  useEffect(() => {
    setElementVars(document.body, { [textDecorationHoverColor]: getRandomColor() })
  }, [])
  return null
}

const getRandomColor = () => HOVER_COLORS[Math.floor(Math.random() * HOVER_COLORS.length)]
